import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-dialog-mask p-component-overlay p-component-overlay-enter",
  style: {"z-index":"999999"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-spin pi-spinner mr-2",
    style: {"font-size":"4rem","color":"#2196F3"}
  })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.show,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event)),
    modal: true,
    closable: false,
    closeOnEscape: false,
    showHeader: false,
    contentClass: "portal-loader"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible"]))
}